import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '@/contexts/AuthContext';
import { sanitizeSupabaseError } from '@/lib/errorHandler';
import { normalizarCidade } from '@/lib/marketplace';
import {
  listarCategoriasOrg, definirCategoriasOrg, listarCidadesOrg,
  adicionarCidadeOrg, removerCidadeOrg, definirDescricaoPublica,
} from '@/services/marketplace.service';

export function useMarketplacePerfil() {
  const { organization, refreshOrganization } = useAuthContext();
  const orgId = organization?.id;
  const { t } = useTranslation();
  const qc = useQueryClient();

  const categorias = useQuery({ queryKey: ['org-categorias', orgId], queryFn: () => listarCategoriasOrg(orgId as string), enabled: !!orgId });
  const cidades = useQuery({ queryKey: ['org-cidades', orgId], queryFn: () => listarCidadesOrg(orgId as string), enabled: !!orgId });

  const guardarCategorias = useMutation({
    mutationFn: (ids: string[]) => definirCategoriasOrg(orgId as string, ids),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['org-categorias'] }); toast.success(t('marketplace.admin.saved')); },
    onError: (e) => toast.error(sanitizeSupabaseError(e)),
  });
  const adicionarCidade = useMutation({
    mutationFn: (cidade: string) => adicionarCidadeOrg(orgId as string, cidade.trim(), normalizarCidade(cidade)),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['org-cidades'] }); toast.success(t('marketplace.admin.saved')); },
    onError: (e) => toast.error(sanitizeSupabaseError(e)),
  });
  const removerCidade = useMutation({
    mutationFn: (id: string) => removerCidadeOrg(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['org-cidades'] }),
    onError: (e) => toast.error(sanitizeSupabaseError(e)),
  });
  const guardarDescricao = useMutation({
    mutationFn: (texto: string) => definirDescricaoPublica(texto),
    onSuccess: async () => { await refreshOrganization(); toast.success(t('marketplace.admin.saved')); },
    onError: (e) => toast.error(sanitizeSupabaseError(e)),
  });

  return { categorias, cidades, guardarCategorias, adicionarCidade, removerCidade, guardarDescricao };
}
